import { render, staticRenderFns } from "./szyd.vue?vue&type=template&id=1426ac14&scoped=true"
import script from "./szyd.vue?vue&type=script&lang=js"
export * from "./szyd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1426ac14",
  null
  
)

export default component.exports